// Import 3rd-party dependencies
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

// Import project-specific dependencies
import { ToolsAndResourcesComponent } from '@app/hub/tools-and-resources/tools-and-resources.component';
import { IResourceLink } from '@app/services/app-tools/app-tools.service';
import { FAVORITE_SNACKBAR_COMPONENT_CONSTS } from '@app/config/constants';

export enum EFavoriteSnackBarAction {
  Unfavorite = 0,
  Favorite = 1,
  Managefavorite = 2,
  FavoriteMany = 3
}

export interface FavoriteSnackBarData {
  linkInfo: IResourceLink | IResourceLink[];
  action?: EFavoriteSnackBarAction;
  message?: string;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'hub-favorite-snackbar',
  templateUrl: './favorite-snackbar.component.html',
  styleUrls: ['./favorite-snackbar.component.css']
})
export class FavoriteSnackbarComponent implements OnDestroy, OnInit {
  consts = FAVORITE_SNACKBAR_COMPONENT_CONSTS;
  snackBarData: IResourceLink | IResourceLink[];
  snackBarMessage: string;
  snackBarAction: number;
  favoritesSectionTimeout: NodeJS.Timeout;
  offsetTimeOut: NodeJS.Timeout;
  isMyHub: boolean;
  @Input() activeTab: string;
  @Output() viewFavoritesClick: EventEmitter<string>;

  constructor(
    public snackBarRef: MatSnackBarRef<ToolsAndResourcesComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: FavoriteSnackBarData
  ) {
    this.snackBarData = data.linkInfo;
    this.snackBarAction = data.action;
    this.snackBarMessage = data.message;
    this.activeTab = localStorage.getItem('isShow');
    this.isMyHub = false;
  }

  ngOnInit(): void {
    this.activeTab = localStorage.getItem('isShow');
    this.isMyHub = false;
    this.viewFavoritesClick = new EventEmitter<string>();
  }

  ngOnDestroy(): void {
    if (this.favoritesSectionTimeout) {
      clearTimeout(this.favoritesSectionTimeout);
    }
    if (this.offsetTimeOut) {
      clearTimeout(this.offsetTimeOut);
    }
  }

  navigateToFavoritesList(): void {
    let timeOut = 0;
    document.getElementById('MyHubButton').click();

    if (this.activeTab !== this.consts.VALUE_MYHUB) {
      timeOut = this.consts.FAVORITES_SECTION_TIMEOUT;
      this.isMyHub = true;
      this.activeTab = this.consts.VALUE_MYHUB;
      localStorage.setItem('isShow', this.activeTab);
      this.viewFavoritesClick.emit(this.activeTab);
    }

    if (this.favoritesSectionTimeout) {
      clearTimeout(this.favoritesSectionTimeout);
    }

    this.favoritesSectionTimeout = setTimeout(() => {
      const favorites = document.getElementById('HubFavorites');
      const offsetPosition = favorites.offsetTop - 70;
      this.scrollToPageContent(offsetPosition);

      if (this.isMyHub) {
        if (this.offsetTimeOut) {
          clearTimeout(this.offsetTimeOut);
        }
        this.isMyHub = false;
        this.offsetTimeOut = setTimeout(() => {
          this.scrollToPageContent(offsetPosition);
        }, this.consts.OFFSET_TIMEOUT);
      }
    }, timeOut);
  }

  get favoriteAction(): typeof EFavoriteSnackBarAction {
    return EFavoriteSnackBarAction;
  }

  scrollToPageContent(offsetPosition: number): void {
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}
